export var tableHeadCellDefaultTheme = {
  Root: {
    base: {}
  }
};